
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { CurrentDateProps } from "./CurrentDate.types";
import CalendarIcon from 'assets/images/calendaricon.svg';
import i18next from 'i18next';

const CurrentDateWrapper = styled.button`
  font-family: Almoni aaa, sans-serif;
  background: #FFFFFF;
  border: 1px solid #EFF1FA;
  box-sizing: content-box;
  width: auto;
  border-radius: 15px;
  padding: 6px 12px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 26px;
  color: #0B223A;
  display: flex;
  align-items: center;
  white-space: nowrap;
`

export const CurrentDate: React.FC<CurrentDateProps> = ({ lang = 'en' }) => {

  const [currentDate, setCurrrentDate] = useState<string>('');

  useEffect(() => {
    let today = new Date();
    setCurrrentDate(`${today.getDate()}  ${today.toLocaleString(i18next.language=="he"?"he":"us", { month: 'long' })}`)
  },[])

  return(
    <CurrentDateWrapper>
      <img style={{ marginRight: 10 }} src={CalendarIcon}/>
      {currentDate}
    </CurrentDateWrapper>
  )
};

